import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/series/[slug]/SeriesDetailClient.tsx");
